import React from "react";
import { cn } from "../../lib/utils";
import { useNetworkStatus } from "@/hooks/use-network-status";
import { useMuiModal } from "../modal";
import { NotAvailableInOfflineModeModal } from "../not-available-in-offline-mode-modal";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "outline" | "orange" | "ghost";
  size?: "default" | "small" | "icon";
  disabledInOfflineMode?: boolean;
}

export function Button({
  className,
  variant = "default",
  size = "default",
  disabledInOfflineMode = false,
  ...props
}: ButtonProps) {
  const networkStatus = useNetworkStatus();
  const { showModal } = useMuiModal();

  const isOfflineDisabled =
    disabledInOfflineMode && networkStatus.data === "disconnected";

  return (
    <span className="relative inline-block">
      <button
        className={cn(
          "rounded-md font-[500] transition-colors text-[32px]",
          "[&]:disabled:opacity-50 rounded-xl border-3 shadow-lg border-bub-vivid-blue",
          "h-full",
          variant === "default" && "bg-bub-vivid-blue text-white",
          variant === "outline" &&
            "bg-white text-bub-vivid-blue hover:bg-gray-50",
          variant === "orange" && "bg-bub-orange border-bub-orange text-white",
          variant === "ghost" && "border-none shadow-none",
          size === "default" && "px-16 py-4",
          size === "small" && "px-8 py-2",
          size === "icon" && "p-0",
          className?.includes(`font-helvetica`) && "pt-4 pb-2",
          isOfflineDisabled && "opacity-50",
          className,
        )}
        {...props}
        onClick={(e) => {
          if (isOfflineDisabled) {
            showModal(<NotAvailableInOfflineModeModal />);
            return;
          } else {
            props.onClick?.(e);
          }
        }}
      />
      {isOfflineDisabled && (
        <span className="absolute inset-0 flex items-center justify-center pointer-events-none text-red-600 font-bold text-[80px] leading-none">
          ✕
        </span>
      )}
    </span>
  );
}
